import { memo } from "react";
import { Grid2 } from "@mui/material";
import { useOnMobile } from "@core/hooks/useOnMobile";
import Chat from "../components/main/Chat";
import ChatSidebar from "../components/sidebar/ChatSidebar";
import { useViewSlice } from "@store/slices/view";
import { availableViewportHeight } from "@core/layout/AppLayout";

const ChatPage = memo(() => {
    const onMobile = useOnMobile();
    const { showExtendedView } = useViewSlice();

    return (
        <Grid2 container size={12} spacing={4.5} pb={0} sx={{ border: `${showExtendedView ? 1 : 0}px solid red` }} height={availableViewportHeight} overflow={"hidden"}>
            {!onMobile && (
                <Grid2 container minWidth={280} maxWidth={"25%"} width={320}>
                    <ChatSidebar />
                </Grid2>
            )}

            <Grid2 container size={"grow"}>
                <Chat />
            </Grid2>
        </Grid2>
    );
});

export default ChatPage;
